exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pattern-input .el-radio{margin-right:20px}.pattern-input .el-radio__label,.pattern-input input,.pattern-input textarea{font-size:13px;color:navy}.pattern-input .number .el-input{width:144px}.pattern-input .number input{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11a988d9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/PatternInput.vue
// module id = 1641
// module chunks = 1